import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authorize, login } from "../../services/accountService";
import Logo from "../Logo";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showError, setShowError] = useState("hidden");

  useEffect(() => {
    try {
        const auth = async () => {
            try {
                const r = await authorize();
                console.log(r)
                const {user} = r;
                if (!user) {
                    return
                }
                navigate("/clients")
            }  catch(e) {
                console.log(e)
            }
        }
        auth()
    } catch(e) {
        console.log(e)
        navigate("/");
        return
    }
  }, [navigate])

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      navigate("/clients");
    }
    catch(e) {
      console.log(e)
      setShowError(() => "");
      setTimeout(() => {
        setShowError(() => "hidden");
      }, 5000);
      return;
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-lg">
        <div className="flex justify-center mb-4">
          <Logo size={48} />
        </div>
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Login
        </h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              type="email"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Password
            </label>
            <input
              type="password"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div>
            <h6>
              <a className="text-blue-800 cursor-pointer hover:underline" onClick={() => navigate('/forgot-password')}>forgot password?</a>
            </h6>
          </div>
          <div>
            <h6 className={`text-red-800 ${showError}`}>
              Incorrect email or password
            </h6>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-800 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Log In
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
